var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"/404.svg","alt":"404"}}),_c('h1',[_vm._v(_vm._s(_vm.$t('Page not found')))])])}
var staticRenderFns = []

export { render, staticRenderFns }